/**
 * An aborted request must surface as an abort, not as a load failure.
 *
 * Checked by name on any object: `fetch` rejects with a `DOMException`, which
 * is not an `Error` in every environment (jsdom), and some callers raise a
 * plain `Error` named `AbortError`.
 */
export const isAbortError = (error: unknown): boolean =>
  typeof error === "object" &&
  error !== null &&
  (error as { name?: unknown }).name === "AbortError";
